import * as React from "react";

/**
 * The title of a large modal (Figma: 22px bold, Text/body). Inside `openModal({ title })`,
 * which already wraps it in a heading, render it `as="span"`.
 */
export const ModalHeading = ({
  children,
  as: Tag = "h2",
}: {
  children: React.ReactNode;
  as?: "h2" | "span";
}) => (
  <Tag className="text-[22px] font-bold leading-7 tracking-[-0.11px] text-text-body">
    {children}
  </Tag>
);
